/**
 * Pilgrim Shop the look drawer — used by blocks/_pilgrim-collection-spot.liquid.
 *
 * A thin wrapper around the theme's DialogComponent: the spot tile's trigger
 * button calls `pilgrim-stl-drawer/showDialog`, the drawer's close button calls
 * `closeDialog`, and the base class provides focus handling, Esc, backdrop
 * click-to-close, scroll-lock and the dialog-drawer slide animation — identical
 * behaviour to the cart drawer.
 *
 * Video: video-background-component sets src + load() the moment it connects —
 * inside the closed <dialog> that meant ~10 s of video buffered at page load
 * for a drawer most visitors never open (11.7 MB on production, 2026-09-17).
 * The block now renders the component in an inert <template>; it is
 * instantiated on the first open, played on every open and paused on close.
 * (closeDialog is an instance-field arrow in the base class and can't be
 * super-called; the native dialog `close` event covers every close path
 * instead.)
 */
import { DialogComponent } from '@theme/dialog';

class PilgrimStlDrawer extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.refs.dialog?.addEventListener('close', () => {
      for (const video of this.refs.dialog.querySelectorAll('video')) video.pause();
    });
  }

  showDialog() {
    super.showDialog();
    // Reduced motion keeps the poster: no video is created or played.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const template = this.refs.dialog?.querySelector('template.pilgrim-stl__video-template');
    if (template) {
      template.parentElement.appendChild(template.content.cloneNode(true));
      template.remove();
    }
    for (const video of this.refs.dialog?.querySelectorAll('video') ?? []) {
      video.muted = true;
      const playing = video.play();
      if (playing) playing.catch(() => {});
    }
  }
}

if (!customElements.get('pilgrim-stl-drawer')) {
  customElements.define('pilgrim-stl-drawer', PilgrimStlDrawer);
}
